import {Component, Input} from '@angular/core';
import {ColDef, GridApi, GridReadyEvent} from "ag-grid-community";
import {DatePipe} from "@angular/common";
import {ReportingService} from "../../../services/reporting.service";
import {IPlayerRetentionReportResult} from "../../../interfaces/reporting/IPlayerRetentionReportResult";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {DateService} from "../../../services/date.service";
import {
  ComponentLevelErrorMessageComponent
} from "../../display-errors/component-level-error-message/component-level-error-message.component";
import {MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {FormsModule} from "@angular/forms";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {AgGridAngular} from "ag-grid-angular";
import {LoadingCardContentComponent} from "../../../shared/loading-card-content/loading-card-content.component";
import {IGameInstance} from "../../../interfaces/IGameInstance";

@Component({
  selector: 'app-sales-per-game',
  standalone: true,
  templateUrl: './sales-per-game.component.html',
  imports: [
    ComponentLevelErrorMessageComponent,
    MatFormField,
    MatDatepickerInput,
    FormsModule,
    MatHint,
    MatLabel,
    MatInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatButton,
    AgGridAngular,
    LoadingCardContentComponent
  ],
  styleUrls: ['./sales-per-game.component.scss']
})
export class SalesPerGameComponent {

  @Input() set setDefaultGameInstanceDrawDate(gameInstanceData: IGameInstance) {
    this.reportingService.fetchSalesPerGameReport(gameInstanceData.GameId).subscribe({
      next: (reportResP) => {

        if (reportResP.length > 0) {
          this.possibleDrawDates = reportResP.map((reportP) => {
            return reportP.EndedOn;
          })
          this.allRetentionReports = reportResP;
          this.drawDate = gameInstanceData.EndedOn;
          this.filterResultsPerGameDrawDate();
        }

        this.uiState = UIStateEnum.ShowData;
      },
      error: () => {
        this.errorMessage = 'There was an issue retrieving your retention report. ' +
          'Please try refreshing the page or reaching out to a system administrator.';
        this.uiState = UIStateEnum.ShowData;
      }
    })
  }

  public uiState = UIStateEnum.ShowLoading;
  public uiStateForTemplate = UIStateEnum;
  public allRetentionReports: IPlayerRetentionReportResult[] = [];
  public possibleDrawDates: Date[] = [];
  public filteredRetentionReportsByGameNumber: IPlayerRetentionReportResult[] = [];
  public errorMessage: string = '';
  public drawDate: Date | null = null;
  public retentionReportDefs: ColDef[] = [
    {
      headerName: 'Draw Date',
      resizable: true,
      sortable: true,
      width: 250,
      field: 'EndedOn',
      valueFormatter: params => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y HH:mm');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'Started On',
      resizable: true,
      sortable: true,
      width: 250,
      field: 'StartedOn',
      valueFormatter: params => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y HH:mm');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'New Registrations',
      resizable: true,
      wrapHeaderText: true,
      sortable: true,
      field: 'NewPlayerCount'
    },
    {
      headerName: 'New Players Who Played',
      resizable: true,
      wrapHeaderText: true,
      sortable: true,
      field: 'NewPlayersWhoPlayed'
    },
    {
      headerName: 'Returning Players',
      resizable: true,
      wrapHeaderText: true,
      sortable: true,
      field: 'ReturningPlayers'
    },
    {
      headerName: 'Total Players',
      resizable: true,
      wrapHeaderText: true,
      sortable: true,
      field: 'TotalPlayers'
    }
  ];

  public retentionGridApi!: GridApi<IPlayerRetentionReportResult>;

  constructor(private reportingService: ReportingService,
              private dateService: DateService,
              private datePipe: DatePipe) {
  }

  filterResultsPerGameDrawDate(overrideP: boolean = false) {
    if (this.drawDate && !overrideP) {
      this.filteredRetentionReportsByGameNumber = this.allRetentionReports.filter((reportP) => {
        return this.dateService.areDatesSameDay(reportP.EndedOn, this.drawDate!)
      });

      return;
    }

    this.drawDate = null;
    this.filteredRetentionReportsByGameNumber = this.allRetentionReports;
  }

  onRetentionGridReady(params: GridReadyEvent<IPlayerRetentionReportResult>) {
    this.retentionGridApi = params.api;
    this.retentionGridApi.sizeColumnsToFit({
      defaultMinWidth: 90,
    });
  }
}
